import {middleDateFormatter, simpleTimeFormatter, toDateFromServer} from './formatter'
import {airportName} from './helper'

export const voloAndataTitle = (from) => {
  if (!from.vector) return ''
  const sigla = from.vector.objB
  const dataOra = from.voli[0].partenza.dataOra
  const data = middleDateFormatter(toDateFromServer(dataOra.date.date))
  const ora = simpleTimeFormatter(dataOra.time.time[0], dataOra.time.time[1])
  return `${sigla} - ${data} ${ora}`
}

export const voloAndataTooltip = (from) => {
  if (!from.vector) return ''
  const nomeVettore = from.vector.objA
  const volo = from.voli[0]
  const partenza = volo.partenza
  const nomeAeroporto = airportName(partenza.aeroporto.airport.objA)
  const numeroVolo = volo.numeroVolo
  const classe = volo.datiProposta.classe
  return tooltip(`${nomeAeroporto}<br>${nomeVettore}<br>N° ${numeroVolo} ${classe}`, 300)
}

export const voloRitornoTitle = (to) => {
  if (!to.vector) return ''
  const sigla = to.vector.objB
  const dataOra = to.voli[0].partenza.dataOra
  const data = middleDateFormatter(toDateFromServer(dataOra.date.date))
  const ora = simpleTimeFormatter(dataOra.time.time[0], dataOra.time.time[1])
  return `${sigla} - ${data} ${ora}`
}

export const voloRitornoTooltip = (to) => {
  if (!to.vector) return ''
  const nomeVettore = to.vector.objA
  const volo = to.voli[0]
  const partenza = volo.partenza
  const nomeAeroporto = airportName(partenza.aeroporto.airport.objA)
  const numeroVolo = volo.numeroVolo
  const classe = volo.datiProposta.classe
  return tooltip(`${nomeAeroporto}<br>${nomeVettore}<br>N° ${numeroVolo} ${classe}`, 300)
}

export const tooltip = (content, width) => {
  return {content, template: `<div class="tooltip ${this.type}"><div class='tooltip-inner' style="position: relative; left: -25%; min-width: ${width}px">${content}</div></div>`}
}



// WEBPACK FOOTER //
// ./src/front/utils/flightUtils.js